import * as React from 'react'
import classNames from 'classnames'
import { DisabledItemHoverInfotip } from 'uiComponents/infotip'
import { LucideIcon } from 'utils/lucideIcon'
import { addSeparators } from 'utils'
import { PRODUCTS } from 'capacity/copy'
import { USES_MAX, USES_MIN } from 'capacity/staging/capacityDraft'

interface UsesStepperProps {
    productName: string
    value: number
    changed: boolean
    onChange: (next: number) => void
}

export function UsesStepper({ productName, value, changed, onChange }: UsesStepperProps) {
    const atMin = value <= USES_MIN
    const atMax = value >= USES_MAX
    return (
        <span className="capacity-uses-stepper" aria-label={`${productName}: ${addSeparators(value)}`}>
            <span className={classNames('capacity-uses-value', { changed })}>{addSeparators(value)}</span>
            <span className="capacity-uses-buttons">
                <DisabledItemHoverInfotip active={atMax} infotipText={PRODUCTS.stepper.atMax} width="16em" toTheLeft>
                    <button
                        type="button"
                        className="capacity-uses-btn"
                        aria-label={PRODUCTS.stepper.more(productName)}
                        disabled={atMax}
                        onClick={() => onChange(value + 1)}
                    >
                        <LucideIcon iconName="ChevronUp" size={16} />
                    </button>
                </DisabledItemHoverInfotip>
                <DisabledItemHoverInfotip active={atMin} infotipText={PRODUCTS.stepper.atMin} width="16em" toTheLeft>
                    <button
                        type="button"
                        className="capacity-uses-btn"
                        aria-label={PRODUCTS.stepper.less(productName)}
                        disabled={atMin}
                        onClick={() => onChange(value - 1)}
                    >
                        <LucideIcon iconName="ChevronDown" size={16} />
                    </button>
                </DisabledItemHoverInfotip>
            </span>
        </span>
    )
}
